var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragLast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 39,
    viewBox: "0 0 13 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 6.875L6.5 4.125L3.75 6.875",
    stroke: "#999999",
    strokeWidth: 1.60417,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 16.5234C5.32373 16.5234 5.6875 16.1597 5.6875 15.7109C5.6875 15.2622 5.32373 14.8984 4.875 14.8984C4.42627 14.8984 4.0625 15.2622 4.0625 15.7109C4.0625 16.1597 4.42627 16.5234 4.875 16.5234Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 16.5234C8.57373 16.5234 8.9375 16.1597 8.9375 15.7109C8.9375 15.2622 8.57373 14.8984 8.125 14.8984C7.67627 14.8984 7.3125 15.2622 7.3125 15.7109C7.3125 16.1597 7.67627 16.5234 8.125 16.5234Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 20.3125C5.32373 20.3125 5.6875 19.9487 5.6875 19.5C5.6875 19.0513 5.32373 18.6875 4.875 18.6875C4.42627 18.6875 4.0625 19.0513 4.0625 19.5C4.0625 19.9487 4.42627 20.3125 4.875 20.3125Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 20.3125C8.57373 20.3125 8.9375 19.9487 8.9375 19.5C8.9375 19.0513 8.57373 18.6875 8.125 18.6875C7.67627 18.6875 7.3125 19.0513 7.3125 19.5C7.3125 19.9487 7.67627 20.3125 8.125 20.3125Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 24.1016C5.32373 24.1016 5.6875 23.7378 5.6875 23.2891C5.6875 22.8403 5.32373 22.4766 4.875 22.4766C4.42627 22.4766 4.0625 22.8403 4.0625 23.2891C4.0625 23.7378 4.42627 24.1016 4.875 24.1016Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 24.1016C8.57373 24.1016 8.9375 23.7378 8.9375 23.2891C8.9375 22.8403 8.57373 22.4766 8.125 22.4766C7.67627 22.4766 7.3125 22.8403 7.3125 23.2891C7.3125 23.7378 7.67627 24.1016 8.125 24.1016Z",
    fill: "#999999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 32.125L6.5 34.875L9.25 32.125",
    stroke: "#999999",
    strokeWidth: 1.60417,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragLast);
export default __webpack_public_path__ + "static/media/DragLast.8db70a3062a322bd5529fcb142957d23.svg";
export { ForwardRef as ReactComponent };